import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.campaign;

export const campaignSelectors = {
  activeCampaign: createSelector(selector, (state) => state.activeCampaign),
};
